import adapter from "webrtc-adapter";
import JsSIP from "jssip";
import "../css/Dailer.css";
import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import styled from "styled-components";
import AlohaaLogo from "../assets/images/AlohaaLogoWhite.png";
import phoneWhite from "../assets/images/phoneWhite.png";
import logoutLogo from "../assets/images/logout.png";
import MicOff from "../assets/images/mic_off.svg";
import Mic from "../assets/images/mic.svg";
import Play from "../assets/images/play_arrow.svg";
import Pause from "../assets/images/pause.svg";
import GreyPause from "../assets/images/GreyPause.svg";
import CallNotesWhite from "../assets/images/callNotesWhite.svg";
import CallNotesGrey from "../assets/images/callNotesGrey.svg";
import GreyMic from "../assets/images/GreyMic.svg";
import HangupLogo from "../assets/images/RecoveryHangup.webp";
import Help from "../assets/images/help.svg";
import tickAnimaiton from "../assets/images/tickAnimation.json";
import InfoRed from "../assets/images/infoRed.png";
import { GET, POST, PUT, DELETE } from "../services/HttpRequests";
import SearchIcon from "../assets/images/search-grey.svg";
import { useSocket } from "../providers/SocketProvider";
import { TURN_SERVER_CONFIG } from "../assets/constants/pbx";
import CallMissedLogo from "../assets/images/phone_missed.svg";
import CallAnsweredLogo from "../assets/images/phone_forwarded.svg";
import phoneGreen from "../assets/images/call-green.svg";
import AddContact from "../assets/images/add-contact-icon.svg";
import ContactPerson from "../assets/images/contact-person.svg";
import DeleteContact from "../assets/images/delete-contact.svg";
import Settings from "../assets/images/settings.svg";
import GreenTick from "../assets/images/greenTickSmall.png";
import LogOutRed from "../assets/images/logout-red.svg";
//import AudioPlayer from "./AudioPlayer";
import {
  setIsOpen,
  setisMicOff,
  setIsPaused,
  setIsCallInProgress,
  setNumbers,
  setDestinationNumber,
  setDid,
  setCallType,
  setCallStatus,
  setUAList,
  setRTCSessionData,
  setTimer,
  setRunTimer,
  setCallId,
  setShowDailNextButton,
  setDailNextTimer,
  setContactId,
  setAgentStatus,
  setDisposition,
  setDispositions,
  setTurnServerConfigs,
} from "../actions/dailerActions";
import DispositionPage from "./DispositionPage";
import { decryptData } from "../utility/cryptoUtils";

const cloudCallUrl = process.env.REACT_APP_CLOUD_CALL_CENTER;
const outgoingCallsUrl = process.env.REACT_APP_OUTGOING_CALLS_API;
const orgUrl = process.env.REACT_APP_ORGANIZATION_API;
const agentHangupUrl = process.env.REACT_APP_ENV === "DEV" ? cloudCallUrl : process.env.REACT_APP_AGENT_HANGUP_API
JsSIP.debug.enable("JsSIP:*");
const sip_details = JSON.parse(localStorage.getItem("sip_details"));
const username = sip_details?.username;
const password = sip_details?.username;

const GradientDiv = styled.div`
  height: 98px;
  background: linear-gradient(#f8153b, #920c23);
  display: flex;
  flex-direction: row;
`;

const CallLogsSearchDiv = styled.div`
  height: 37px;
  flex-shrink: 0;
  background: #fef7ff;
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
`;

const DailerDiv = styled.div`
  height: 295px,
  background: light,
  border-radius: 0px,
`;

const DailButton = styled.div`
  width: 230px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 32px;
  background: #07aa3f;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const EndButton = styled.div`
  width: 230px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 32px;
  background: #f8153b;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DailNextButton = styled.div`
  width: 230px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 32px;
  border: 2px solid #07aa3f;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DailPad = (props) => {
  const isOpen = useSelector((state) => state.dailer.isOpen);
  const isMicOff = useSelector((state) => state.dailer.isMicOff);
  const isPaused = useSelector((state) => state.dailer.isPaused);
  const isCallInProgress = useSelector(
    (state) => state.dailer.isCallInProgress
  );
  const numbers = useSelector((state) => state.dailer.numbers);
  const destinationNumber = useSelector(
    (state) => state.dailer.destinationNumber
  );
  const did = useSelector((state) => state.dailer.did);
  const callType = useSelector((state) => state.dailer.callType);
  const callStatus = useSelector((state) => state.dailer.callStatus);
  const UAList = useSelector((state) => state.dailer.UAList);
  const RTCSessionData = useSelector((state) => state.dailer.RTCSessionData);
  const dispositions = useSelector((state) => state.dailer.dispositions);
  const disposition = useSelector((state) => state.dailer.disposition);
  const timer = useSelector((state) => state.dailer.timer);
  const turnServerConfigs = useSelector((state) => state.dailer.turnServerConfigs);
  const runTimer = useSelector((state) => state.dailer.runTimer);
  const callId = useSelector((state) => state.dailer.callId);
  const showDailNextButton = useSelector(
    (state) => state.dailer.showDailNextButton
  );
  const dailNextTimer = useSelector((state) => state.dailer.dailNextTimer);
  const contactId = useSelector((state) => state.dailer.contactId);
  const agentStatus = useSelector((state) => state.dailer.agentStatus);
  const buttonRef = useRef(null);
  const {
    setIsOpen,
    setisMicOff,
    setIsPaused,
    setIsCallInProgress,
    setNumbers,
    setDestinationNumber,
    setDid,
    setCallType,
    setCallStatus,
    setUAList,
    setRTCSessionData,
    setTimer,
    setRunTimer,
    setCallId,
    setShowDailNextButton,
    setDailNextTimer,
    setAgentStatus,
    setContactId,
    numberFromIframe,
    isEditable,
    encryptPhoneNumber,
    externalId,
    setDisposition,
    setDispositions,
    setTurnServerConfigs
  } = props;

  const orgId = localStorage.getItem("doosra-biz-organisation-id");
  const isWebRTCEnabled = localStorage.getItem("is_webrtc_enabled");
  const sipDetails = localStorage.getItem("sip_details");
  const isBrowserCallEnabledForUser =
    isWebRTCEnabled === "true" &&
    Object.keys(JSON.parse(sipDetails)).length > 0;
  const [loading, setLoading] = useState(false);
  const [callComment, setCallComment] = useState("");
  const [distanceToRight, setDistanceToRight] = useState("");
  const [showDispositionUpdatedMessage, setShowDispositionUpdatedMessage] =
    useState(false);
  const [error, setError] = useState("");
  const [selectedView, setSelectedView] = useState("Dailer");
  const [callLogs, setCallLogs] = useState([]);
  const [contactsList, setContactsList] = useState([]);
  const [isSettingsPageSelected, setIsSettingsPageSelected] = useState(false);
  const [showAddContactPage, setShowAddContactPage] = useState(false);
  const [contactName, setContactName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [showDeletePopUp, setShowDeletePopUp] = useState(null);
  const [selectedCallRecordingId, setSelectedCallRecordingId] = useState("");
  const [dailerPage, setDailerPage] = useState("dailer-page");
  const clickedElementRef = useRef(null);
  const socket = useSocket();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: tickAnimaiton,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if(showDailNextButton) {
      resetValues();
    }
    let numberToDial = numberFromIframe;
    if(encryptPhoneNumber) {
      const last4Digits = numberFromIframe.slice(-4);
      numberToDial = `XXXXXX${last4Digits}`
    }
    setDestinationNumber({ destinationNumber: numberToDial });
    if(!isEditable) {
      const inputElement = document.getElementById('number-input');
      if (inputElement) {
        inputElement.setAttribute('readonly', '');
      }
    } 
    if(isEditable) {
      const inputElement = document.getElementById('number-input');
      if (inputElement && inputElement.hasAttribute('readonly')) {
        inputElement.removeAttribute('readonly');
      }
    }
  }, [numberFromIframe])

  useEffect(() => {
    if (clickedElementRef.current) {
      clickedElementRef.current.scrollIntoView({
        behavior: "auto",
        block: "center",
      });
    }
  }, [selectedCallRecordingId]);

  const logoutHandler = () => {
    PUT(
      cloudCallUrl + "metric/update-agent-break-time",
      {},
      {
        organisationId: localStorage.getItem("doosra-biz-organisation-id"),
        agentId: localStorage.getItem("doosra-biz-user-id"),
        breakSwitch: "on",
        breakReason: "offline",
      }
    )
      .then(() => {
        DELETE(`${orgUrl}v1/auth/logout`)
          .then((res) => {
            if (res?.data?.response?.user_id) {
              localStorage.clear();
              sessionStorage.clear();
              window.location.reload();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    PUT(
      cloudCallUrl + "metric/update-agent-break-time",
      {},
      {
        organisationId: localStorage.getItem("doosra-biz-organisation-id"),
        agentId: localStorage.getItem("doosra-biz-user-id"),
        breakSwitch: "off",
        breakReason: "active",
      }
    )
      .then((res) => {
        console.log("Agent Status " + res.data?.response?.msg);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    GET(`${orgUrl}v1/organisation/basic/details`, {
      organisation_id: localStorage.getItem("doosra-biz-organisation-id"),
    })
      .then((res) => {
        return res.data.response;
      })
      .then((res) => {
        const { is_dialer_widget_enabled, pstn_enabled, webrtc_enabled } =
          res.organisation.add_ons;
        localStorage.setItem("pstn_enabled", pstn_enabled || false);
        localStorage.setItem("webrtc_enabled", webrtc_enabled || false);
        localStorage.setItem(
          "is_dialer_widget_enabled",
          is_dialer_widget_enabled || false
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const destroyWebsocketConnection = (domain) => {
    if (domain) {
      UAList.forEach(({ ua }) => {
        if (ua.hostport_params === domain) {
          ua.stop();
        }
      });
    } else {
      UAList.forEach(({ ua }) => {
        ua.stop();
      });
    }
    setUAList({ UAList: [] });
  };

  const resetValues = () => {
    setTimer({ timer: 0 });
    setIsCallInProgress({ isCallInProgress: false });
    setShowDailNextButton({ showDailNextButton: false });
    setDestinationNumber({ destinationNumber: "" });
    setCallStatus({ callStatus: "Ringing" });
    setDailNextTimer({ dailNextTimer: 10 });
    setContactId({ contactId: '' });
    setCallId({ callId: '' });
    setIsPaused({ isPaused: false });
    setisMicOff({ isMicOff: false });
    setDisposition({ disposition: '' });
    setCallComment('');
  };

  const CallMissed = () => {
    return (
      <div className="call-missed-logo">
        <img src={CallMissedLogo} width="14px" height={"14px"}></img>
      </div>
    );
  };

  const CallAnswered = () => {
    return (
      <div className="call-answered-logo">
        <img src={CallAnsweredLogo} width="14px" height={"14px"}></img>
      </div>
    );
  };

  const ContactImage = () => {
    return (
      <div className="contact-logo">
        <img src={ContactPerson} width="14px" height={"14px"}></img>
      </div>
    );
  };

  function formatDate(date) {
    const givenDate = moment(date);

    if (givenDate.isSame(moment(), "day")) {
      return `Today`;
    } else if (givenDate.isSame(moment().subtract(1, "days"), "day")) {
      return `Yesterday`;
    } else {
      return givenDate.format("DD/MM/YYYY");
    }
  }
  const handleCallRecording = (callId) => {
    if (callId === selectedCallRecordingId) {
      setSelectedCallRecordingId("");
    } else {
      setSelectedCallRecordingId(callId);
    }
  };

  const CallLogsDiv = () => {
    return callLogs.length > 0 ? (
      <div style={{ height: "260px", overflowY: "scroll" }}>
        {callLogs.map((callLog) => (
          <div
            ref={
              callLog._id === selectedCallRecordingId ? clickedElementRef : null
            }
            className="call-log-main-container"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleCallRecording(callLog._id);
            }}
          >
            <div className="call-log">
              {callLog.status === "answered" ? (
                <CallAnswered />
              ) : (
                <CallMissed />
              )}
              <span style={{ marginLeft: "6px" }}>
                <div className="contact-name">
                  {callLog.contact_name || "Unknown Number"}
                </div>
                <div className="contact-number">
                  {callLog.destinationNumber}
                </div>
              </span>
              <span style={{ position: "relative", right: "14px" }}>
                <div className="call-time">
                  {moment(callLog.createdAt).format("hh:mm A")}
                </div>
                <div className="call-time">{formatDate(callLog.createdAt)}</div>
              </span>
              <span
                style={{
                  position: "relative",
                  right: "6px",
                  cursor: isCallInProgress ? "not-allowed" : "pointer"
                }}
                onClick={(e) => {
                  if (!isCallInProgress) {
                    e.preventDefault();
                    e.stopPropagation();
                    setCallId({ callId: callLog._id });
                    setDestinationNumber({
                      destinationNumber: callLog.destinationNumber,
                    });
                    setSelectedView("Dailer");
                  }
                }}
              >
                <img src={phoneGreen} width={"16px"} height={"16px"}></img>
              </span>
            </div>
            {/* {callLog.recording && selectedCallRecordingId === callLog._id && (
              <div>
                <AudioPlayer callRecordingUrl={callLog.recording} />
              </div>
            )} */}
          </div>
        ))}
        <div className="call-log-overflow">
          <p className="call-log-overflow-p">
            {" "}
            To view the full call logs list visit{" "}
          </p>
          <span>
            <a href="https://business.alohaa.ai/login" target="_blank">
              business.alohaa.ai
            </a>
          </span>
        </div>
      </div>
    ) : (
      <div style={{ position: "relative" }}>
        <div className="no-contacts">
          <p className="no-contacts-text">No calls have been made yet.</p>
        </div>
      </div>
    );
  };

  const deleteContactHandler = (id) => {
    setLoading(true);
    const userId = localStorage.getItem("doosra-biz-user-id");
    DELETE(orgUrl + "v1/user/contact", null, { id, userId })
      .then((res) => {
        if (!res?.data?.response?.success) {
          fetchContacts();
          setShowDeletePopUp(false);
        } else {
          fetchContacts();
          setShowDeletePopUp(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log("err", err);
      });
  };

  const DeleteContactPopUp = (props) => {
    return props.showDeletePopUp ? (
      <div className="delete-popup-main-container">
        <div className="delete-popup">
          <img
            className="delete-popup-logo"
            src={DeleteContact}
            width={"25px"}
            height={"25px"}
            alt="Delete"
          />
          <label className="delete-popup-label">Delete contact?</label>
          <div className="delete-popup-contact">
            <div>
              <span className="delete-popup-contact-name">{props.name}</span>
            </div>
            <div>
              <span className="delete-popup-contact-number">
                {props.number}
              </span>
            </div>
          </div>
          <div
            className="delete-popup-confirm"
            onClick={() => deleteContactHandler(props.id)}
          >
            <label className="delete-popup-delete-label">Delete</label>
          </div>
          <label className="delete-popup-cancel-label" onClick={props.onHide}>
            Cancel
          </label>
        </div>
      </div>
    ) : (
      <span
        style={{ marginRight: "12px", cursor: "pointer" }}
        onClick={props.onShow}
      >
        <img src={DeleteContact} width={"20px"} height={"20px"} alt="Delete" />
      </span>
    );
  };

  const ContactsDiv = () => {
    return contactsList.length > 0 ? (
      <div style={{ position: "relative" }}>
        <div className="contacts" style={{ overflowY: "scroll" }}>
          {contactsList.map((userContact) => (
            <div className="contact">
              <ContactImage />
              <span style={{ marginLeft: "12px" }}>
                <div className="contact-name" style={{ width: "190px" }}>
                  {userContact.name || "-"}
                </div>
                <div className="contact-number" style={{ width: "190px" }}>
                  {userContact.phoneNumbers[0] || "-"}
                </div>
              </span>
              <DeleteContactPopUp
                id={userContact._id}
                name={userContact.name}
                number={userContact.phoneNumbers[0]}
                showDeletePopUp={showDeletePopUp === userContact._id}
                onShow={() => setShowDeletePopUp(userContact._id)}
                onHide={() => setShowDeletePopUp(null)}
              />
              <span
                style={{ marginRight: "12px", cursor: isCallInProgress ? "not-allowed" : "pointer" }}
                onClick={() => {
                  if (!isCallInProgress) {
                    setContactId({ contactId: userContact._id });
                    setDestinationNumber({
                      destinationNumber: userContact.phoneNumbers[0],
                    });
                    setSelectedView("Dailer");
                  }
                }}
              >
                <img src={phoneGreen} width={"20px"} height={"20px"}></img>
              </span>
            </div>
          ))}
        </div>
        <div
          className="add-contact"
          onClick={() => setShowAddContactPage(true)}
        >
          <img src={AddContact}></img>
        </div>
      </div>
    ) : (
      <div style={{ position: "relative" }}>
        <div className="no-contacts">
          <p className="no-contacts-text">
            No contacts in your contact book yet
          </p>
        </div>
        <div
          className="add-contact"
          onClick={() => setShowAddContactPage(true)}
        >
          <img src={AddContact}></img>
        </div>
      </div>
    );
  };

  const fetchContacts = async (searchValue = "") => {
    let data = {
      pageNo: 1,
      pageSize: 15,
      organisationId: localStorage.getItem("doosra-biz-organisation-id"),
      userId: localStorage.getItem("doosra-biz-user-id"),
    };
    if (searchValue) {
      data.searchKey = "contact_name";
      data.search_key = "contact_name";
      data.q = searchValue;
      data.searchCondition = searchValue;
    }

    GET(`${orgUrl}v1/user/contacts`, data)
      .then((res) => res.data.response)
      .then((res) => {
        setContactsList(res.contacts);
      })
      .catch((err) => {
        console.log("error occured");
      });
  };

  const fetchCallLogsOfAgent = async (searchValue = "") => {
    let data = {
      pageNo: 1,
      pageSize: 15,
      organisationId: localStorage.getItem("doosra-biz-organisation-id"),
    };
    if (searchValue) {
      data.searchKey = "destinationNumber";
      data.search_key = "destinationNumber";
      data.searchCondition = searchValue;
      data.q = searchValue;
    }

    GET(`${outgoingCallsUrl}v1/organisations/outbound-call/call-log/list`, data)
      .then((res) => res.data.response)
      .then((res) => {
        setCallLogs(res.items);
      })
      .catch((err) => {
        console.log("error occured");
      });
  };

  const addContact = async () => {
    if (
      !contactName ||
      !contactNumber ||
      isNaN(contactNumber) ||
      contactNumber.length !== 10
    ) {
      return;
    }
    const data = {
      name: contactName,
      phoneNumbers: [contactNumber],
      organisationId: localStorage.getItem("doosra-biz-organisation-id"),
    };
    POST(orgUrl + "v1/user/contact", data)
      .then((res) => {
        setLoading(false);
        setContactName("");
        setContactNumber("");
        fetchContacts();
        setShowDispositionUpdatedMessage(true);
        setShowAddContactPage(false);
        return res;
      })
      .catch((err) => {
        setLoading(false);
        return false;
      });
  };

  const calculateDistance = () => {
    if (buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const distance = window.innerWidth - buttonRect.right;
      console.log("right", distance);
      setDistanceToRight(distance);
    }
  };

  useEffect(() => {
    let interval;
    if (runTimer) {
      interval = setInterval(() => {
        setTimer({});
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [timer, runTimer]);

  useEffect(() => {
    calculateDistance();
  }, []);

  // useEffect(() => {
  //   console.log('Show dail next button interval');
  //   let dailNextInterval;
  //   if (showDailNextButton) {
  //     console.log('Show dail next button interval starting');
  //     dailNextInterval = setInterval(() => {
  //       setDailNextTimer({});
  //     }, 1000);
  //     setTimeout(() => {
  //       resetValues();
  //       clearInterval(dailNextInterval);
  //     }, 10000);
  //   }
  //   return () => {
  //     console.log('clearing the interval', dailNextInterval);
  //     clearInterval(dailNextInterval);
  //   };
  // }, [showDailNextButton]);

  const getDomainName = (socketUrl) => {
    const startIndex = socketUrl.indexOf("//") + 2;
    const endIndex = socketUrl.indexOf("/", startIndex);
    const domainName = socketUrl.substring(startIndex, endIndex);
    return domainName;
  };

  useEffect(() => {
    UAList.forEach(({ ua: UA }) => {
      UA.on("disconnected", (e) => {
        UA.unregister({ all: true });
        const disconnectedSocket = e.socket._url;
        const domainName = getDomainName(disconnectedSocket);
        destroyWebsocketConnection(domainName);
      });
      UA.on("connected", (e) => {
        const connectedSocket = e.socket.socket._url;
        console.log("user registered successfully", connectedSocket);
        UA.register();
        /*
          1. DONT USE CONNECTED EVENT TO SEND THE CONNECTION STATUS BECAUSE IT IS 
            TRIGGERED BEFORE THE WEBSOCKET CONNECTION IS ESTABLISHED COMPLETELY.
          2. USE REGISTERED EVENT TO SEND THE CONNECTION STATUS BECAUSE IT IS THE MAIN 
            EVENT THAT IS TRIGGERED AFTER THE WEBSOCKET CONNECTION IS ESTABLISHED COMPLETELY.
        */
        // const domainName = getDomainName(connectedSocket);
        // setTimeout(() => {
        //   sendSocketConnectionStatus(domainName, "connected")
        // }, 1000);
      });
      UA.on("registered", (e) => {
        console.log("user registered successfully");
        // setIsAuthenticatedUser(true);
      });
      UA.on("registrationFailed", (e) => {
        console.log("user registration failed");
        // setIsAuthenticatedUser(false);
      });
      UA.on("unregistered", () => {
        console.log("user unregistration event");
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UAList]);
  useEffect(() => {
    const RTCSessions = [];
    UAList.forEach(({ ua: UA }) => {
      UA.on("newRTCSession", (e) => {
        console.log("Setting the newRTCSession");
        const newSession = e.session;
        let options = {
          mediaConstraints: { audio: true, video: false },
          pcConfig: {},
          rtcOfferConstraints: { offerToReceiveAudio: true, offerToReceiveVideo: false }
        };
        /* START ICE CONFIG */
        let iceServers = [
          {
            urls: ["stun:stun.l.google.com:19302"],
          }  
        ];
        const pbx = newSession._ua._configuration.hostport_params;
        const pbxConfig = turnServerConfigs[pbx]
        const turnConfig = {
          urls: [`turn:${pbx}:3478`,`turn:${pbx}:5349`,`turns:${pbx}:3478`,`turns:${pbx}:5349`],
          username:pbxConfig.username,
          credential: pbxConfig.credential
        }
        iceServers.push(turnConfig);
        options.pcConfig["iceServers"] = iceServers;
        newSession.on("icecandidate", (candidate) => {
          console.log("iceCandidate gathered - ", candidate);
        });
        /* END ICE CONFIG */
        if (newSession.direction === "incoming" && !newSession.isEnded()) {
          setRTCSessionData({ RTCSessionData: newSession });
          RTCSessions.push(newSession);
          newSession.on("accepted", function (event) {
            console.log(" Call Accepted ");
          });
          newSession.on("confirmed", function (event) {
            if (event.originator === "remote") {
            }
          });
          // Call failed event
          newSession.on("failed", (event) => {
            resetValues();
            console.log(" Call failed ", event);
            if(event.cause === "User Denied Media Access") {
              setError("Call failed due to microphone issue.")
            }
            else{
              setError("Call failed due to network error.")
            }
            // resetValues();
          });
          // Call hungup event
          newSession.on("ended", (event) => {
            console.log(" Call hangup ");
            // resetValues();
          });
          // Answer Call
          if (!newSession.isEnded()) {
            newSession.answer(options);
            console.log("iceConnectionState - ", newSession);
          }
          const remoteAudioEl = document.getElementById('remoteAudio');
          // Audio connection For Modren browsers
          newSession.connection.addEventListener('track', (e) => {
            if (!remoteAudioEl) {
              console.warn('remoteAudio element not found');
              return;
            }
            remoteAudioEl.srcObject = e.streams[0];
          });

          // Legacy fallback: addstream (for older Chrome/Firefox)
          newSession.connection.addEventListener('addstream', (event) => {
            remoteAudioEl.srcObject = event.stream;
          });
        }
      });
      return () => {
        UA.removeAllListeners("newRTCSession");
      };
    });
  }, [UAList]);

  useEffect(() => {
    if (socket) {
      socket.on("callConnected", (message, cb) => {
        console.log("ReceivedEvent callConnected", message);
        setCallStatus({ callStatus: "Answered" });
        setRunTimer({ runTimer: true });
        setCallId({ callId: message.callId });
        cb({
          status: "Acknowledged",
        });
      });
      socket.on("callEnd", (message, cb) => {
        console.log("ReceivedEvent callEnd", message);
        setCallStatus({ callStatus: "Ended" });
        setIsOpen({ isOpen: true });
        setAgentStatus({ agentStatus: "Online" });
        handleAgentStatus('Online');
        setRunTimer({ runTimer: false });
        setShowDailNextButton({ showDailNextButton: true });
        cb({
          status: "Acknowledged",
        });
      });
    }
  }, [socket]);
  useEffect(() => {
    GET(cloudCallUrl + `outbound/organisation/did-numbers`, {
      pageNo: 0,
      pageSize: 1000,
      organisation_id: orgId,
      active: true,
    })
      .then((res) => res.data.response)
      .then((res) => {
        setNumbers({ numbers: res.items });
        if (res.items.length >= 1) {
          setDid({ did: res.items[0]._id });
        } else {
          setDid({ did: "" });
        }
      })
      .catch((err) => console.log(err));
    getDispositions();
  }, []);

  const handleAgentStatus = async (eventKey) => {
    const breakReasonMap = {
      'Break': 'break',
      'Online': 'active',
      'Busy': 'busy'
    };

    let breakReason = breakReasonMap[eventKey] || 'offline';
    const data = {
      organisationId: localStorage.getItem('doosra-biz-organisation-id'),
      agentId: localStorage.getItem('doosra-biz-user-id'),
      breakSwitch: "",
      breakReason
    }
    if (eventKey === 'Online') {
      data.breakSwitch = 'off';
    }
    else {
      data.breakSwitch = 'on';
    }
    console.log(data);
    await PUT(cloudCallUrl + 'metric/update-agent-break-time', {}, data)
      .then((res) => {
        return true;
      })
      .catch((err) => {
        return false;
      });
  }

  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    let formattedTime;
    if (hours > 0) {
      formattedTime = `${hours.toString().padStart(2, "0")}: ${minutes
        .toString()
        .padStart(2, "0")}: ${remainingSeconds.toString().padStart(2, "0")}`;
    } else {
      formattedTime = `${minutes
        .toString()
        .padStart(2, "0")}: ${remainingSeconds.toString().padStart(2, "0")}`;
    }
    return formattedTime;
  }

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [callType]);

  const handleBeforeUnload = () => {
    console.log("In the handle before", callType);
    if (callType === "VOIP") {
      callEnd();
    }
    resetValues();
    destroyWebsocketConnection();
  };

  const handleWebsocketConnection = () => {
    if (agentStatus === "Online" && isWebRTCEnabled === "true") {
      GET(
        cloudCallUrl +
        `outbound/get-active-domains-organisation?organisationId=${orgId}`
      )
        .then((res) => res.data.response)
        .then((res) => {
          const activeDomains = res?.activeDomains || [];
          let activeTurnConfigs = res?.turnConfigs || {};

          Object.entries(activeTurnConfigs).forEach(([key, value]) => {
            const decryptedCredential = decryptData(value.credential);
            activeTurnConfigs[key] = {
              ...value,
              credential: decryptedCredential,
            };
          });
          if (activeDomains?.length > 0) {
            const uaList = activeDomains.map((server) => {
              const socket = new JsSIP.WebSocketInterface(`wss://${server}/ws`);
              const uaConfig = {
                uri: `sip:${username}@${server}`,
                password: password,
                sockets: [socket],
                connection_recovery_min_interval: 5,
              };
              const ua = new JsSIP.UA(uaConfig);
              ua.start();
              return { ua: ua };
            });
            setTurnServerConfigs({ turnServerConfigs: activeTurnConfigs });
            setUAList({ UAList: uaList });
            return uaList;
          }
        })
        .catch((err) => console.log(err));
    }
    if (agentStatus !== "Online" && agentStatus !== "Busy") {
      if (callType === "VOIP") {
        callEnd();
      }
      resetValues();
      destroyWebsocketConnection();
      setIsOpen({ isOpen: false });
    }
  };

  useEffect(() => {
    handleWebsocketConnection();
  }, [agentStatus]);

  const getDispositions = () => {
    setLoading(true);
    const data = {
      organisationId: localStorage.getItem('doosra-biz-organisation-id'),
    };
    return GET(cloudCallUrl + 'disposition', data)
      .then((res) => {
        setDispositions({ dispositions: res.data.response.dispositions });
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        setError(err?.response?.data?.error?.reason);
        return false;
      });
  };

  useEffect(() => {
    if (showDispositionUpdatedMessage) {
      setTimeout(() => {
        setShowDispositionUpdatedMessage(false);
      }, 3000);
    }
  }, [showDispositionUpdatedMessage]);

  const updateDisposition = (callId, disposition, callComment) => {
    setLoading(true);
    const data = {
      callId,
    };

    if (disposition) {
      data.disposition = disposition;
    }

    if (callComment) {
      data.callComment = callComment;
    }

    return PUT(
      cloudCallUrl + 'outbound/update-disposition-outbound-call',
      {},
      data
    )
      .then((res) => {
        if (callComment) {
          setCallComment(callComment);
        }
        if (disposition) {
          setDisposition({ disposition });
        }
        setShowDispositionUpdatedMessage(true);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        setError(err?.response?.data?.error?.reason);
        return false;
      });
  };

  const micOn = () => {
    if (RTCSessionData) {
      RTCSessionData.unmute();
    }
  };

  const micOff = () => {
    if (RTCSessionData) {
      RTCSessionData.mute();
    }
  };

  const holdCall = () => {
    if (RTCSessionData) {
      RTCSessionData.hold();
    }
  };

  const unHoldCall = () => {
    if (RTCSessionData) {
      RTCSessionData.unhold();
    }
  };
  const callEnd = async () => {
    console.log('RTCSessionData', RTCSessionData, RTCSessionData?.status, RTCSessionData?.C?.STATUS_TERMINATED);
    if (RTCSessionData && RTCSessionData.status !== RTCSessionData?.C?.STATUS_TERMINATED) {
      RTCSessionData.terminate();
    } else {
      if(callId) {
        const url = process.env.REACT_APP_ENV === "DEV" ? 'cloud-call/agent-hangup' : 'v1/call-center/agent-hangup';
        console.log("CallEnd - callId :", callId);
        const requestData = {
          callId
        }
        await POST(agentHangupUrl + url, requestData);
      } 
    }
    setCallStatus({ callStatus: "Ended" });
    setIsOpen({ isOpen: true });
    setAgentStatus({ agentStatus: "Online" });
    handleAgentStatus('Online');
    setRunTimer({ runTimer: false });
    setShowDailNextButton({ showDailNextButton: true });   
  };
  const initiateCall = () => {
    if (!contactId && !callId) {
      if (!destinationNumber) {
        setError("Destination Number is required");
        return;
      }
      if (
        destinationNumber.length !== 10 ||
        isNaN(encryptPhoneNumber ? numberFromIframe : destinationNumber) === true
      ) {
        setError("Please check the destination number");
        return;
      }
    }
    if (!did) {
      if (numbers.length === 0) {
        setError("No Caller ID Available");
      } else {
        setError("Please Select Caller ID");
      }
      return;
    }
    if (!callType) {
      setError("Please Select Call Connectivity");
      return;
    }
    const callData = {
      number: encryptPhoneNumber ? numberFromIframe : destinationNumber,
      didId: did,
      contactId: null,
      userId: localStorage.getItem("doosra-biz-user-id"),
      organisationId: localStorage.getItem("doosra-biz-organisation-id"),
      callType,
      contactId,
      callId,
      externalId: externalId || ""
    };
    POST(`${cloudCallUrl}cloud-call/initiate-outbound-call`, callData)
      .then((res) => {
        setCallId({ callId: res.data.response.referenceId });
        console.log("The call ils being connected");
        setIsCallInProgress({ isCallInProgress: true });
        setAgentStatus({ agentStatus: "Busy" });
        handleAgentStatus('Busy');
        setError("");
      })
      .catch((err) => {
        console.log("The error is", err);
        setError("Call Initation Failed");
      });
  };
  return (
    <div className="dailer-div">
      <audio
        id="remoteAudio"
        autoPlay
        playsInline
        controls={false} 
      />
      <GradientDiv>
        <div className="gradient-div-main">
          <img src={AlohaaLogo} width={24} height={20} alt="alohaa"></img>
        </div>
        <img
          src={logoutLogo}
          onClick={() => {
            setIsSettingsPageSelected(false);
            setSelectedView("Logout");
          }}
          className="gradient-div-logout"
          alt="down"
        ></img>
        <img
          src={Settings}
          onClick={() => {
            setIsSettingsPageSelected(true);
          }}
          className="gradient-div-settings"
          alt="down"
        ></img>
        <p className="gradient-div-label">Alohaa dailer </p>
      </GradientDiv>
      {isSettingsPageSelected ? (
        <div className="settings-main">
          <div
            style={{ display: "flex", alignItems: "center", height: "60px" }}
          >
            <p className="settings-header">Your account details</p>
          </div>
          <div>
            <label className="settings-label">Name</label>
          </div>
          <div>
            <label className="settings-info">
              {localStorage.getItem("doosra-biz-user-name")}
            </label>
          </div>
          <div>
            <label className="settings-label">Phone Number</label>
          </div>
          <div>
            <label className="settings-info">
              {localStorage.getItem("doosra-biz-user-number")}
            </label>
          </div>
          <div>
            <label className="settings-label">Email address</label>
          </div>
          <div>
            <label className="settings-info">
              {localStorage.getItem("doosra-biz-user-email")}
            </label>
          </div>

          <label
            className="settings-back"
            onClick={() => {
              setSelectedView("Dailer")
              setIsSettingsPageSelected(false)
            }}
          >
            Back
          </label>
        </div>
      ) : (
        <>
          <Divider>
            <div
              onClick={() => {
                setSelectedView("Dailer");
              }}
            >
              <span
                className={
                  selectedView === "Dailer"
                    ? "divider-text-active"
                    : "divider-text-inactive"
                }
              >
                Dailer
              </span>
            </div>
            <div
              onClick={() => {
                setSelectedView("Call logs");
                fetchCallLogsOfAgent();
              }}
            >
              <span
                className={
                  selectedView === "Call logs"
                    ? "divider-text-active"
                    : "divider-text-inactive"
                }
              >
                Call logs
              </span>
            </div>
            <div
              onClick={() => {
                setSelectedView("Contacts");
                fetchContacts();
              }}
            >
              <span
                className={
                  selectedView === "Contacts"
                    ? "divider-text-active"
                    : "divider-text-inactive"
                }
              >
                Contacts
              </span>
            </div>
          </Divider>
          {selectedView === "Dailer" ? (
            isCallInProgress ? (
              <DailerDiv>
                {dailerPage === "dailer-page" && <>
                  <div className="customer-name-timer-main-div">
                    <label className="destination-label">Single Call</label>
                    <label className="call-timer-label">
                      {formatTime(timer)}
                    </label>
                  </div>
                  <div style={{ display: "flex" }}>
                    <label className="destination-number-label">{`+91 ${destinationNumber}`}</label>
                    <label
                      className="call-status-label"
                      style={{
                        color: showDailNextButton ? "red" : "green",
                      }}
                    >
                      {callStatus}
                    </label>
                  </div>
                  <div className="call-controls-main-div">
                    <div className="tooltip-container">
                      <div
                        className="mic"
                        style={{
                          background:
                            callStatus === "Ringing" ||
                              callStatus === "Ended" ||
                              callType === "PSTN"
                              ? "#D9D9D9"
                              : isMicOff
                                ? "red"
                                : "white",

                          border: `1px solid ${callStatus === "Ringing" ||
                            callStatus === "Ended" ||
                            callType === "PSTN"
                            ? "#D9D9D9"
                            : "red"
                            }`,
                          cursor: callType === "PSTN" ? "not-allowed" : "pointer",
                        }}
                        onClick={() => {
                          if (callStatus !== "Ringing") {
                            if (isMicOff) {
                              micOn();
                            } else {
                              micOff();
                            }
                            setisMicOff({ isMicOff: !isMicOff });
                          }
                        }}
                      >
                        <img
                          src={
                            callStatus === "Ringing" ||
                              callStatus === "Ended" ||
                              callType === "PSTN"
                              ? GreyMic
                              : isMicOff
                                ? MicOff
                                : Mic
                          }
                          alt="call"
                        ></img>
                      </div>
                      {(callStatus === "Answered" || callStatus === "Ringing") &&
                        callType === "PSTN" && (
                          <div
                            className="tooltip-text top"
                            data-tip-position="top"
                          >
                            Manage GSM calls On Mobile.
                          </div>
                        )}
                    </div>

                    <div className="tooltip-container">
                      <div
                        className="hold"
                        style={{
                          background:
                            callStatus === "Ringing" ||
                              callStatus === "Ended" ||
                              callType === "PSTN"
                              ? "#D9D9D9"
                              : isPaused
                                ? "red"
                                : "white",

                          border: `1px solid ${callStatus === "Ringing" ||
                            callStatus === "Ended" ||
                            callType === "PSTN"
                            ? "#D9D9D9"
                            : "red"
                            }`,
                          cursor: callType === "PSTN" ? "not-allowed" : "pointer",
                        }}
                        onClick={() => {
                          if (callStatus !== "Ringing") {
                            if (isPaused) {
                              unHoldCall();
                            } else {
                              holdCall();
                            }
                            setIsPaused({ isPaused: !isPaused });
                          }
                        }}
                      >
                        <img
                          src={
                            callStatus === "Ringing" ||
                              callStatus === "Ended" ||
                              callType === "PSTN"
                              ? GreyPause
                              : isPaused
                                ? Play
                                : Pause
                          }
                          alt="call"
                        ></img>
                      </div>
                      {(callStatus === "Answered" || callStatus === "Ringing") &&
                        callType === "PSTN" && (
                          <div
                            className="tooltip-text top"
                            data-tip-position="top"
                          >
                            Manage GSM calls On Mobile.
                          </div>
                        )}
                    </div>

                    <div className="tooltip-container">
                      <div
                        className="dispositionIcon"
                        style={{
                          background:
                            callStatus === "Answered" || callStatus === "Ended"
                              ? "white"
                              : "#D9D9D9",
                          border: `1px solid ${callStatus === "Answered" || callStatus === "Ended"
                            ? "red"
                            : "#D9D9D9"
                            }`,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (callStatus === "Answered" || callStatus === "Ended") {
                            setDailerPage("disposition-page");
                          }
                        }}
                      >
                        <img
                          style={{ width: '14px', height: '14px' }}
                          src={
                            callStatus === "Answered" || callStatus === "Ended"
                              ? CallNotesWhite
                              : CallNotesGrey
                          }
                          alt="call"
                        ></img>
                      </div>
                      <div
                        className="tooltip-text top"
                        data-tip-position="top"
                      >
                        Call Notes
                      </div>
                    </div>
                  </div>
                  {showDailNextButton ? (
                    <DailNextButton
                      className="dial-next-main-div"
                      onClick={() => resetValues()}
                    >
                      <label className="dial-next-label">Dial Next</label>
                    </DailNextButton>
                  ) : (
                    <EndButton
                      style={{
                        background: callType === "PSTN" ? "lightgrey" : "red",
                        cursor: callType === "PSTN" ? "not-allowed" : "pointer",
                      }}
                      className="end-button-div"
                      onClick={() => callEnd()}
                    >
                      <img src={HangupLogo} alt="hangup"></img>
                    </EndButton>
                  )}
                </>}
                {dailerPage === "disposition-page" &&
                  <DispositionPage
                    destinationName={"Single Call"}
                    destinationNumber={destinationNumber}
                    callStatus={callStatus}
                    timer={formatTime(timer)}
                    dispositions={dispositions}
                    disposition={disposition}
                    showDispositionUpdatedMessage={showDispositionUpdatedMessage}
                    updateDisposition={updateDisposition}
                    callId={callId}
                    goToBack={() => setDailerPage("dailer-page")}
                    callComment={callComment}
                    setCallComment={setCallComment}
                  />}
              </DailerDiv>
            ) : (
              <DailerDiv>
                <p className="enter-number-label">Enter number</p>
                <input
                  id="number-input"
                  type={"text"}
                  value={destinationNumber}
                  className="enter-number-input"
                  onChange={(e) => {
                    if (callId) {
                      setCallId({ callId: "" });
                    }
                    if (contactId) {
                      setContactId({ contactId: "" });
                    }
                    const destinationNo = e.target.value.replace(
                      /[^0-9#]/g,
                      ""
                    );
                    setDestinationNumber({ destinationNumber: destinationNo });
                  }}
                ></input>
                <p className="caller-id-label">Select Caller ID</p>
                <select
                  className="enter-number-input"
                  disabled={
                    numbers.length === 1 || numbers.length === 0 ? true : false
                  }
                  onChange={(e) => {
                    setDid({ did: e.target.value });
                  }}
                >
                  <>
                    {numbers.length === 0 && (
                      <option value="" selected={did === "" ? true : false}>
                        No Caller ID available
                      </option>
                    )}
                    {numbers.length === 1 &&
                      numbers.map((number) => (
                        <option key={number._id} value={number._id}>
                          {number.virtualNumber}
                        </option>
                      ))}
                    {numbers.length > 1 &&
                      numbers.map((number) => (
                        <option
                          key={number._id}
                          value={number._id}
                          selected={number._id === did}
                        >
                          {number.virtualNumber}
                        </option>
                      ))}
                  </>
                </select>
                <p
                  style={{
                    margin:
                      localStorage.getItem("webrtc_enabled") !== "true" ||
                        !isBrowserCallEnabledForUser
                        ? "10px 110px 10px 30px"
                        : "10px 125px 10px 30px",
                    color: "black",
                  }}
                >
                  Call Connectivity
                  {(localStorage.getItem("webrtc_enabled") !== "true" ||
                    !isBrowserCallEnabledForUser) && (
                      <div className="tooltip-container">
                        <img
                          src={Help}
                          style={{ marginLeft: "4px" }}
                          alt="help"
                        ></img>
                        <div className="tooltip-text top" data-tip-position="top">
                          Upgrade to get broswer calling
                        </div>
                      </div>
                    )}
                </p>
                <div>
                  <label className="gsm-label">
                    <input
                      type="radio"
                      value="PSTN"
                      checked={callType === "PSTN"}
                      disabled={
                        !(localStorage.getItem("pstn_enabled") === "true")
                      }
                      onChange={() => {
                        setCallType({ callType: "PSTN" });
                      }}
                    />
                    &nbsp; GSM
                  </label>
                  <label className="browser-label">
                    <input
                      type="radio"
                      value="VOIP"
                      checked={callType === "VOIP"}
                      disabled={
                        !(localStorage.getItem("webrtc_enabled") === "true") ||
                        !isBrowserCallEnabledForUser
                      }
                      onChange={() => {
                        setCallType({ callType: "VOIP" });
                      }}
                    />
                    &nbsp; Browser
                  </label>
                </div>
                <DailButton
                  className="dail-button"
                  onClick={() => initiateCall()}
                >
                  <img src={phoneWhite} alt="phone"></img>
                </DailButton>
                <div className="error-div">
                  {error && (
                    <React.Fragment>
                      <img alt="" src={InfoRed} className="error-img" />
                      {error}
                    </React.Fragment>
                  )}
                </div>
              </DailerDiv>
            )
          ) : null}
          {selectedView === "Call logs" ? (
            <>
              <CallLogsSearchDiv>
                <input
                  type="text"
                  className="call-log-search-box"
                  placeholder="Search by number"
                  onChange={(e) => {
                    setTimeout(() => {
                      fetchCallLogsOfAgent(e.target.value);
                    }, 1000);
                  }}
                ></input>
                <img
                  src={SearchIcon}
                  width={"16px"}
                  height={"16px"}
                  className="call-logs-search"
                ></img>
              </CallLogsSearchDiv>
              <CallLogsDiv />
            </>
          ) : null}
          {selectedView === "Contacts" ? (
            showAddContactPage ? (
              <div className="add-contact-main-div">
                <div>
                  <label
                    className="settings-label"
                    style={{ paddingTop: "24px" }}
                  >
                    Contact name
                  </label>
                </div>
                <div>
                  <input
                    id="add-contact-name"
                    type={"text"}
                    className="add-contact-input"
                    value={contactName}
                    onChange={(e) => setContactName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="settings-label">Contact phone number</label>
                </div>
                <div>
                  <input
                    type={"text"}
                    className="add-contact-input"
                    id="add-contact-number"
                    value={contactNumber}
                    onChange={(e) => {
                      const unSanitizedNumber = e.target.value;
                      const sanitizedNumber = unSanitizedNumber.replace(
                        /\D/g,
                        ""
                      );
                      setContactNumber(sanitizedNumber);
                    }}
                  />
                </div>
                {showDispositionUpdatedMessage ? (
                  <label className="contact-added-label">
                    <img
                      className="disposition-updated"
                      src={GreenTick}
                      alt="contact added"
                    />
                    Contact Added
                  </label>
                ) : null}
                <div
                  onClick={() => addContact()}
                  className="save-contact-button"
                >
                  <label className="save-contact-label">Save contact</label>
                </div>
                <label
                  onClick={() => setShowAddContactPage(false)}
                  className="settings-back"
                  style={{ bottom: "32px" }}
                >
                  Back
                </label>
              </div>
            ) : (
              <>
                <CallLogsSearchDiv>
                  <input
                    type="text"
                    className="call-log-search-box"
                    placeholder="Search by contact name"
                    id="contact-search"
                    onChange={(e) => fetchContacts(e.target.value)}
                  ></input>
                  <img
                    src={SearchIcon}
                    width={"16px"}
                    height={"16px"}
                    className="call-logs-search"
                  ></img>
                </CallLogsSearchDiv>
                <ContactsDiv />
              </>
            )
          ) : null}
          {selectedView === "Logout" ? (
            <div className="logout-main">
              <img
                src={LogOutRed}
                width={"32px"}
                height={"32px"}
                className="logout-img"
              ></img>
              <label className="logout-label">
                Are you sure you want to log out?
              </label>
              <div onClick={() => logoutHandler()} className="logout-confirm">
                Yes
              </div>
              <label
                onClick={() => setSelectedView("Dailer")}
                className="logout-cancel"
              >
                Cancel
              </label>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  setIsOpen,
  setisMicOff,
  setIsPaused,
  setIsCallInProgress,
  setNumbers,
  setDestinationNumber,
  setDid,
  setCallType,
  setCallStatus,
  setUAList,
  setRTCSessionData,
  setTimer,
  setRunTimer,
  setCallId,
  setShowDailNextButton,
  setDailNextTimer,
  setContactId,
  setAgentStatus,
  setDisposition,
  setDispositions,
  setTurnServerConfigs
})(DailPad);
